import { createSelector } from 'reselect'
import viewTypes from 'helpers/enums/viewTypes'
import currentViewSelector from 'redux/selectors/ui/currentViewSelector'

const currentViewProperties = {
	[viewTypes.LIBRARY]: 'My Library',
	[viewTypes.STORE_PREVIEW]: 'Store Preview Page',
}

export default createSelector(
	[currentViewSelector],
	currentView => currentViewProperties[currentView] || 'Other Page'
)
